// Scope codes checked by the API (KTPL-API-Gateway user/constants.py), per module.
// A role holding SUPERADMIN_SCOPE has every scope.
export const SUPERADMIN_SCOPE = '*';

const crud = (module) => ({
    LIST: `${module}.list`,
    READ: `${module}.read`,
    CREATE: `${module}.create`,
    UPDATE: `${module}.update`,
    DELETE: `${module}.delete`,
});

// Masters: their lists fill pickers, so only changes are scoped.
const masterCrud = (module) => ({
    CREATE: `${module}.create`,
    UPDATE: `${module}.update`,
    DELETE: `${module}.delete`,
});

export const SCOPES = {
    DASHBOARD: {
        VIEW: 'dashboard.view',
    },
    BOOKING: {
        ...crud('booking'),
        DISPATCH: 'booking.dispatch',
        VENDOR_ASSIGN: 'booking.vendor_assign',
        CANCEL: 'booking.cancel',
        CLOSE: 'booking.close',
        STATUS_UPDATE: 'booking.status_update',
        FORCE_UPDATE: 'booking.force_update',
        EXPORT: 'booking.export',
        CHANGE_REQUEST_VIEW: 'booking.change_request_view',
        CHANGE_REQUEST_RESPOND: 'booking.change_request_respond',
    },
    PROFORMA_INVOICE: {
        ...crud('proforma_invoice'),
        DOWNLOAD: 'proforma_invoice.download',
    },
    INVOICE: {
        ...crud('invoice'),
        CANCEL: 'invoice.cancel',
        GENERATE_IRN: 'invoice.generate_irn',
        DOWNLOAD: 'invoice.download',
        EXPORT: 'invoice.export',
    },
    VENDOR_INVOICE: {
        ...crud('vendor_invoice'),
        CANCEL: 'vendor_invoice.cancel',
        DOWNLOAD: 'vendor_invoice.download',
        EXPORT: 'vendor_invoice.export',
    },
    CREDIT_NOTE: {
        ...crud('credit_note'),
        GENERATE_IRN: 'credit_note.generate_irn',
        DOWNLOAD: 'credit_note.download',
        EXPORT: 'credit_note.export',
    },
    DEBIT_NOTE: {
        ...crud('debit_note'),
        DOWNLOAD: 'debit_note.download',
        EXPORT: 'debit_note.export',
    },
    REPORT: {
        BOOKING_AUDIT: 'report.booking_audit',
        PROFIT_LOSS: 'report.profit_loss',
        CUSTOMER_SALES: 'report.customer_sales',
        MONTHLY_TURNOVER: 'report.monthly_turnover',
        BILL_COVER: 'report.bill_cover',
        AGREEMENT_EXPIRY: 'report.agreement_expiry',
        DOCUMENT_EXPIRY: 'report.document_expiry',
        FLEET: 'report.fleet',
        VEHICLE_SALES: 'report.vehicle_sales',
        VEHICLE_PRODUCTIVITY: 'report.vehicle_productivity',
        SERVICE_DUE: 'report.service_due',
        RATING: 'report.rating',
        DOWNLOAD: 'report.download',
    },
    TRIP: {
        LIST: 'trip.list',
        CREATE: 'trip.create',
        UPDATE: 'trip.update',
        EXPORT: 'trip.export',
    },
    VEHICLE_EXPENSE: {
        ...crud('vehicle_expense'),
        EXPORT: 'vehicle_expense.export',
    },
    CUSTOMER: crud('customer'),
    CUSTOMER_USER: crud('customer_user'),
    CONTRACT: {
        ...crud('contract'),
        EXPORT: 'contract.export',
    },
    VENDOR: crud('vendor'),
    DRIVER: crud('driver'),
    VEHICLE: {
        ...crud('vehicle'),
        EXPORT: 'vehicle.export',
    },
    BRANCH: masterCrud('branch'),
    SERVICE_LOCATION: masterCrud('service_location'),
    VEHICLE_TYPE: masterCrud('vehicle_type'),
    VEHICLE_MAKE: masterCrud('vehicle_make'),
    PACKAGE: masterCrud('package'),
    USER: crud('user'),
    ROLE: {
        LIST: 'role.list',
        CREATE: 'role.create',
        UPDATE: 'role.update',
        DELETE: 'role.delete',
        PERMISSIONS: 'role.permissions',
    },
    SETUP: {
        SETTINGS: 'setup.settings',
    },
};

/**
 * Whether the granted scopes hold any of the required ones.
 * `required` is a scope, a list of scopes (any of them is enough) or empty (always allowed).
 */
export const hasScope = (granted = [], required) => {
    const needed = Array.isArray(required) ? required : [required];
    if (!required || needed.length === 0) return true;
    if (granted?.includes(SUPERADMIN_SCOPE)) return true;
    return needed.some((scope) => granted?.includes(scope));
};

// Every scope of a module group, for "any of them is enough" checks: anyScope(SCOPES.BRANCH).
export const anyScope = (group) => Object.values(group);
